import { forwardRef } from 'react'
import type { CountryCode } from 'libphonenumber-js'
import PhoneNumberInput from 'react-phone-number-input'
import { TextField, type TextFieldProps } from '~/components/shared'

export interface PhoneInputFieldProps extends Omit<TextFieldProps, 'onChange'> {
  onChange: (value: string | undefined) => void
  defaultCountry: CountryCode | undefined
  value?: string | undefined
}

const PhoneNumberCustomInput = forwardRef((props, ref) =>
  <TextField ref={ref as any} {...props as any} />
)
PhoneNumberCustomInput.displayName = "PhoneNumberCustomInput"

export const PhoneInputField = (props: PhoneInputFieldProps) => {
  return (
    <PhoneNumberInput
      international
      id={props.id}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      focusInputOnCountrySelection={false}
      addInternationalOption
      autoComplete="off"
      defaultCountry={props.defaultCountry}
      disabled={props.disabled}
      inputComponent={PhoneNumberCustomInput}
      numberInputProps={{
        error: props.error,
        helperText: props.helperText,
        label: props.label,
        wrapperClassName: "w-full",
        className: "!pl-[4.5rem]",
        optional: props.optional,
      }}
      // flagComponent={ ... } // TODO: custom flag component
      // containerComponentProps={{ arrowComponent: ... }} // TODO: custom arrow component
      className="relative [&>*:first-child]:absolute [&>*:first-child]:left-6 [&>*:first-child]:top-4 [&>*:first-child]:z-10 [&>*:first-child]:transform"
    />
  )
}
